/**
 * Helper function to get Contentful image URL with transformations
 * This is a client-safe utility that doesn't require Contentful environment variables
 */
export function getContentfulImageUrl(
  asset: unknown,
  options: {
    width?: number;
    height?: number;
    quality?: number;
    format?: "webp" | "jpg" | "png";
    fit?: "pad" | "fill" | "scale" | "crop" | "thumb";
  } = {},
): string {
  const assetTyped = asset as {
    fields?: {
      file?: {
        url?: string;
      };
    };
  };

  if (!assetTyped?.fields?.file?.url) {
    return "";
  }

  const baseUrl = assetTyped.fields.file.url.startsWith("//")
    ? `https:${assetTyped.fields.file.url}`
    : assetTyped.fields.file.url;

  const params = new URLSearchParams();

  if (options.width) params.append("w", options.width.toString());
  if (options.height) params.append("h", options.height.toString());
  if (options.quality) params.append("q", options.quality.toString());
  if (options.format) params.append("fm", options.format);
  if (options.fit) params.append("fit", options.fit);

  const queryString = params.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
